import React, { useState, useLayoutEffect } from 'react';
import Switcher from '../Switcher';

const CRM_NOTIFICATIONS_SOUND = 'crm-notifications-sound';

interface ISoundSwitcher {
  className?: string;
  setIsNotificationsSoundEnabled: (isSoundEnabled: boolean) => void;
}

export const SoundSwitcher = ({
  className,
  setIsNotificationsSoundEnabled,
}: ISoundSwitcher): JSX.Element => {
  const [isSoundEnabled, setIsSoundEnabled] = useState(
    localStorage.getItem(CRM_NOTIFICATIONS_SOUND) === 'on'
  );

  useLayoutEffect(() => {
    const ls = localStorage.getItem(CRM_NOTIFICATIONS_SOUND);
    if (ls) {
      setIsSoundEnabled(ls === 'on');
      setIsNotificationsSoundEnabled(ls === 'on');
    } else {
      localStorage.setItem(CRM_NOTIFICATIONS_SOUND, 'on');
      setIsSoundEnabled(true);
      setIsNotificationsSoundEnabled(true);
    }
  }, []);

  const handleChange = () => {
    setIsSoundEnabled(prev => {
      localStorage.setItem(CRM_NOTIFICATIONS_SOUND, !prev ? 'on' : 'off');
      setIsNotificationsSoundEnabled(!prev);
      return !prev;
    });
  };

  return (
    <Switcher
      className={className}
      isChecked={isSoundEnabled}
      onSwitch={handleChange}
    />
  );
};
